import { createReducer } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import {
  fetchInitializeCommunication,
  fetchedInitializeCommunication,
  submitStep1,
  submitStep2,
  setIsBulkCommunication,
  saveCommunications,
  fetchedSaveCommunications,
} from './actions';
import { State } from './types';
import { clearStateSlice } from '../clear-slice/actions';

export const INITIAL_STATE: State = {
  initializeCommunication: {
    status: undefined,
    error: undefined,
    data: undefined,
  },
  saveCommunication: {
    status: undefined,
    error: undefined,
    data: undefined,
  },
  isBulkCommunication: undefined,
  firstStepformValues: {
    customersSelection: 1,
    impactedStations: [],
    excludedStations: [],
    selectedCarriages: [],
    includePassengersWithoutSeats: true,
    selectedTypologiesIds: [],
    selectedConflictTypeId: undefined,
    excludeAllConflictTypes: false,
    selectedPurchaseComparison: undefined,
    purchaseReferenceDate: undefined,
    purchaseReferenceTime: undefined,
    DVNumbers: undefined,
  },
  secondStepformValues: {
    situationId: undefined,
    reasonId: undefined,
    otherReasonComplementary: undefined,
    communicationChannels: [],
    mailObject: undefined,
    mailHeadband: undefined,
    communicationContent: [],
    signature: undefined,
    compensationSelected: false,
  },
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(setIsBulkCommunication, (state, action) => {
      const { payload } = action;
      state.isBulkCommunication = payload;
    })

    .addCase(fetchInitializeCommunication, (state) => {
      state.initializeCommunication.status = 'loading';
      state.initializeCommunication.error = undefined;
    })
    .addCase(fetchedInitializeCommunication, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.initializeCommunication.error = payload as RequestError;
        state.initializeCommunication.status = 'error';
      } else {
        state.initializeCommunication.data = payload as State['initializeCommunication']['data'];
        state.initializeCommunication.error = undefined;
        state.initializeCommunication.status = 'success';
      }
    })

    .addCase(saveCommunications, (state) => {
      state.saveCommunication.status = 'loading';
      state.saveCommunication.error = undefined;
      state.saveCommunication.data = {
        ...state.saveCommunication.data,
        message: undefined,
      };
    })
    .addCase(fetchedSaveCommunications, (state, action) => {
      const { error, payload } = action;
      state.saveCommunication.data = payload.data;
      if (error === true) {
        state.saveCommunication.error = payload.error;
        state.saveCommunication.status = 'error';
      } else {
        state.saveCommunication.error = undefined;
        state.saveCommunication.status = 'success';
      }
    })

    .addCase(submitStep1, (state, action) => {
      const { payload } = action;
      state.firstStepformValues = {
        ...state.firstStepformValues,
        ...payload,
      };
    })

    .addCase(submitStep2, (state, action) => {
      const { payload } = action;
      state.secondStepformValues = {
        ...state.secondStepformValues,
        ...payload,
      };
    })

    .addCase(clearStateSlice, (state, action) => {
      const { payload } = action;
      if (payload?.sliceReducer === 'SendCommunication') {
        if (payload?.oneLevelNestedPathKeys) {
          const firstKey = payload.oneLevelNestedPathKeys[0] as 'initializeCommunication' | 'saveCommunication';
          const secondKey = payload.oneLevelNestedPathKeys[1];
          return {
            ...state,
            [firstKey]: {
              ...state[firstKey],
              [secondKey]: INITIAL_STATE[firstKey][secondKey],
            },
          };
        } else {
          return INITIAL_STATE;
        }
      }
      return state;
    })
);
